module.exports = __webpack_public_path__ + "static/worker/download.worker.2bf9d19.js";


// WEBPACK FOOTER //
// ./src/worker/download.worker.js